// commonMethods.js

// Validate email format
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  export function isValidPhoneNumber(phoneNumber) {
    // Regex for Indian phone numbers starting with 6, 7, 8, or 9 without hyphens
    const phoneRegex = /^[6-9]\d{9}$/;
    const isValidFormat = phoneRegex.test(phoneNumber);
    return isValidFormat;
  }
 // Validate text (non-empty and only text)
export function isValidText(text) {
    // Regular expression to match only alphabets (uppercase and lowercase)
    const textRegex = /^[a-zA-Z]+$/;
  
    // Check if the text is non-empty and contains only alphabets
    return text.trim() !== '' && textRegex.test(text);
  }
  
  export function preventTextInput(event) {
    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        event.preventDefault();
    }
}

   
export function preventNumberInput(event) {
  if (!/[^0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      event.preventDefault();
  }
}